import { createColumnHelper } from "@tanstack/react-table";
import { Eye, MoreVertical } from "lucide-react";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";

const columnHelper = createColumnHelper<any>();

const ActionCell = ({
  onPickUp,
  onServe,
}: {
  onPickUp: () => void;
  onServe: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="p-2 text-[#98A2B3] hover:text-[#475467] transition-colors focus:outline-none">
        <MoreVertical className="w-5 h-5" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          anchor="bottom end"
          className="absolute right-0 mt-2 w-48 origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 py-2"
        >
          <div className="px-1 py-1 flex flex-col gap-y-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => navigate("/baliff/case-folders/view")}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center rounded-lg px-4 py-2.5 text-sm`}
                >
                  Open case folder
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={onPickUp}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center rounded-lg px-4 py-2.5 text-sm`}
                >
                  Picked up
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={onServe}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center rounded-lg px-4 py-2.5 text-sm`}
                >
                  Served
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export const BaliffCaseFolderColumns = [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: (info) => (
      <span className="text-[#101828]">{info.row.index + 1}</span>
    ),
  }),
  columnHelper.accessor("date_assigned", {
    header: "Date assigned",
    cell: (info) => <span className="text-[#667085]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("title", {
    header: "Title",
    cell: (info) => (
      <span className="text-[#101828] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("suit_number", {
    header: "Suit number",
    cell: (info) => (
      <span className="text-[#101828] font-semibold">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("details", {
    header: "Details",
    cell: () => (
      <button className="flex items-center gap-1 text-[#101828] hover:text-[#00B074]">
        <span>View</span>
        <Eye className="w-4 h-4" />
      </button>
    ),
  }),
  columnHelper.accessor("assigned_bailiff", {
    header: "Assigned Bailiff",
    cell: (info) => (
      <button className="text-[#1D4ED8] font-medium hover:underline">
        {info.getValue()}
      </button>
    ),
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => (
      <span className="text-[#D97706] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("time_spent", {
    header: "Time Spent",
    cell: (info) => (
      <span className="text-[#00B074] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.display({
    id: "action",
    header: "Action",
    cell: (info) => (
      <ActionCell
        onPickUp={info.row.original.onPickUp}
        onServe={info.row.original.onServe}
      />
    ),
  }),
];
